"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
  Example to use:
  -----------------------------
  timeoutCapableFetch(
    500,
    new Error('Fetch Request timed out!'),
    fetch(url).then().catch((error: Error) => {}),
  ).catch((error: Error) => {
    //timeout
  });
*/
var timeoutCapableFetch = function (timeout, error, promise) {
    return new Promise(function (resolve, reject) {
        promise.then(resolve, reject);
        setTimeout(function () { return reject.bind(null, error); }, timeout);
    });
};
exports.default = timeoutCapableFetch;
//# sourceMappingURL=timeoutCapableFetch.js.map